angular.module('contabilidad.polizas')
  .config(Config)

Config.$inject = ['$stateProvider']

function Config ($stateProvider) {
  $stateProvider.state('contabilidad.polizas.provisionNominaconpagos', {
    url: '/provisionnominaconpagos?{fechaInicio:date}&{fechaFin:date}&:idOperadora&:idsEmpresas&:idsNominas',
    params: {idsEmpresas: {array: true}},
    data: {title: 'Provisión Nómina con pagos'},
    template: '<contabilidad-polizas-provisionnominaconpagos fecha-inicio = "$params.fechaInicio"	fecha-fin = "$params.fechaFin" ids-empresas = "$params.idsEmpresas"	id-operadora = "$params.idOperadora" ids-nominas = "$params.idsNominas"></contabilidad-polizas-provisionnominaconpagos>',
    controller: Controller,
  })
}

Controller.$inject = ['$stateParams', '$scope']

function Controller ($stateParams, $scope) {
  $scope.$params = $stateParams
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/routes/contabilidad-polizas-provisionnominasconpagos.js